<template>
  <div
    class="d-flex flex-column"
    :class="
      item.url_midia_colaboracao && !isFullScreen ? 'mb-14' : !isFullScreen ? 'mb-10' : ''
    "
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <header
      v-if="
        !hideUserInfo &&
        !(
          item.url_midia_colaboracao &&
          item.dsc_texto_colaboracao &&
          item.flg_exibir_texto &&
          midiaOrientation === 'vertical' &&
          !isFullScreen
        )
      "
      class="d-flex flex-wrap-1 px-2 py-2"
    >
      <div class="d-flex align-center" style="margin: 0 auto">
        <span
          class="text-uppercase header-font"
          :class="isFullScreen ? 'text-h4' : ''"
          style="
            color: rgb(255, 255, 255) !important;
            font-size: 1.8rem;
            font-weight: 600;
            font-family: 'NerkoOneRegular !important';
          "
        >
          <template v-if="flgExibirUf && item.dsc_uf_colaborador">
            {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
          </template>
          <template v-else>
            {{ item.dsc_nome_colaborador }}
          </template>
        </span>
      </div>
      <div class="align-self-end align-center d-flex">
        <v-icon
          :size="isFullScreen ? '42' : '42'"
          class="ma-0 pa-0 px-1"
          color="rgb(255, 255, 255)"
          style="transform: scaleX(-1)"
        >
          mdi-chat-outline
        </v-icon>
      </div>
    </header>
    <section
      class="d-flex align-center flex-grow-1"
      :style="
        item.dsc_texto_colaboracao && !item.url_midia_colaboracao && !isFullScreen
          ? 'background: rgb(9,4,62);'
          : !(
              item.url_midia_colaboracao &&
              item.dsc_texto_colaboracao &&
              item.flg_exibir_texto &&
              midiaOrientation === 'vertical' &&
              !isFullScreen
            )
          ? 'background: rgb(9, 4, 62);'
          : ''
      "
    >
      <div
        v-if="renderMode === 'text'"
        v-html="item.dsc_texto_colaboracao"
        class="px-3 py-3 font-weight-normal"
        style="color: rgb(255, 255, 255); font-family: 'GaleanaCondensed-Regular'"
        :style="{
          lineHeight: lineHeight,
          fontSize: bodyTextSize,
          wordBreak: 'break-word',
        }"
      ></div>
      <div
        v-else-if="renderMode === 'texto_fullscreen'"
        v-html="item.dsc_texto_colaboracao"
        class="px-3 py-3 font-weight-normal"
        style="color: rgb(255, 255, 255); font-family: 'GaleanaCondensed-Regular'"
        :style="{
          lineHeight: lineHeightFullScreen,
          fontSize: bodyTextSizeFullSreen,
          wordBreak: 'break-word',
        }"
      ></div>
      <div
        v-else-if="renderMode === 'audio'"
        style="width: 100%"
        class="d-flex align-center align-self-center justify-center px-8"
      >
        <audio
          controls
          controlslist="nodownload"
          autoplay
          style="width: 100%"
          :key="item.url_midia_colaboracao"
        >
          <source :src="item.url_midia_colaboracao" />
        </audio>
      </div>
      <div
        v-else-if="renderMode === 'midia'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'd-flex align-center justify-center pa-2'
            : 'pa-2'
        "
        :id="`${item.id_colaboracao}-wrapper`"
      >
        <img
          v-if="item.dsc_tipo_midia_colaboracao === 'image'"
          :id="`${item.id_colaboracao}`"
          :src="item.url_midia_colaboracao"
          :style="
            isFullScreen
              ? `max-width: ${
                  (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                }px;
                                                                                          min-width: ${
                                                                                            (percentScreenDim.fullScreenMinWidth *
                                                                                              screenDimensions.width) /
                                                                                            100
                                                                                          }px;
                                                                                          max-height: ${
                                                                                            (percentScreenDim.fullScreenMaxHeight *
                                                                                              screenDimensions.height) /
                                                                                            100
                                                                                          }px;
                                                                                          min-height: ${
                                                                                            (percentScreenDim.fullScreenMinHeight *
                                                                                              screenDimensions.height) /
                                                                                            100
                                                                                          }px;`
              : `max-width: ${
                  (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                }px; 
                                                                                           max-height: ${
                                                                                             (percentScreenDim.maxHeight *
                                                                                               screenDimensions.height) /
                                                                                               100 -
                                                                                             50
                                                                                           }px`
          "
        />
        <video
          v-if="item.dsc_tipo_midia_colaboracao === 'video'"
          autoplay
          :id="`${item.id_colaboracao}`"
          :key="item.url_midia_colaboracao"
          style="justify-self: center"
          :style="
            isFullScreen
              ? `max-height: ${
                  (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                }px; 
                                                                                          max-width: ${
                                                                                            (percentScreenDim.fullScreenMaxWidth *
                                                                                              screenDimensions.width) /
                                                                                            100
                                                                                          }px`
              : `max-width: 100%;
                                                  max-height: ${
                                                    (percentScreenDim.maxHeight *
                                                      screenDimensions.height) /
                                                      100 -
                                                    50
                                                  }px`
          "
        >
          <source :src="item.url_midia_colaboracao" />
        </video>
      </div>
      <div
        v-else-if="renderMode === 'midia_texto_fullscreen'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="item.dsc_tipo_midia_colaboracao === 'image' ? 'd-flex align-center' : ''"
      >
        <div
          v-if="midiaOrientation && midiaOrientation === 'horizontal'"
          class="d-flex flex-column align-center pt-2"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            :src="item.url_midia_colaboracao"
            :style="
              isFullScreen
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                                                                                      max-height: ${
                                                                                                        (percentScreenDim.fullScreenMaxHeight *
                                                                                                          screenDimensions.height) /
                                                                                                        100
                                                                                                      }px;
                                                                                                      min-height: ${
                                                                                                        (percentScreenDim.fullScreenMinHeight *
                                                                                                          screenDimensions.height) /
                                                                                                        100
                                                                                                      }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                                                                                      max-height: ${
                                                                                                        (percentScreenDim.maxHeight *
                                                                                                          screenDimensions.height) /
                                                                                                          100 -
                                                                                                        50
                                                                                                      }px`
            "
          />
          <video
            v-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            :style="
              isFullScreen
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                                                                      max-width: ${
                                                                                                        (percentScreenDim.fullScreenMaxWidth *
                                                                                                          screenDimensions.width) /
                                                                                                        100
                                                                                                      }px`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                                                                                      max-height: ${
                                                                                                        (percentScreenDim.maxHeight *
                                                                                                          screenDimensions.height) /
                                                                                                          100 -
                                                                                                        50
                                                                                                      }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
          <div
            v-html="item.dsc_texto_colaboracao"
            class="px-3 mt-2 py-3 font-weight-normal"
            style="
              color: rgb(255, 255, 255);
              font-family: 'GaleanaCondensed-Regular';
              background-color: rgb(24, 1, 243); ;
            "
            :style="{
              lineHeight: lineHeightFullScreen,
              fontSize: bodyTextSizeFullSreen,
              wordBreak: 'break-word',
            }"
          ></div>
        </div>
        <div
          v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
          class="d-flex align-center justify-center"
        >
          <div class="pa-2 d-flex">
            <img
              v-if="item.dsc_tipo_midia_colaboracao === 'image'"
              :src="item.url_midia_colaboracao"
              :style="
                isFullScreen
                  ? `max-width: ${
                      (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                    }px;
                                                                                                              max-height: ${
                                                                                                                (percentScreenDim.fullScreenMaxHeight +
                                                                                                                  10 *
                                                                                                                    screenDimensions.height) /
                                                                                                                100
                                                                                                              }px;
                                                                                                              min-height: ${
                                                                                                                (percentScreenDim.fullScreenMinHeight *
                                                                                                                  screenDimensions.height) /
                                                                                                                100
                                                                                                              }px;`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                              max-height: ${
                                                                                                                (percentScreenDim.maxHeight *
                                                                                                                  screenDimensions.height) /
                                                                                                                  100 -
                                                                                                                50
                                                                                                              }px`
              "
            />
            <video
              v-if="item.dsc_tipo_midia_colaboracao === 'video'"
              autoplay
              :id="`${item.id_colaboracao}`"
              :key="item.url_midia_colaboracao"
              style="justify-self: center"
              :style="
                isFullScreen
                  ? `max-height: ${
                      (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                      100
                    }px; 
                                                                                                              max-width: ${
                                                                                                                (percentScreenDim.fullScreenMaxWidth *
                                                                                                                  screenDimensions.width) /
                                                                                                                100
                                                                                                              }px`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                              max-height: ${
                                                                                                                (percentScreenDim.maxHeight *
                                                                                                                  screenDimensions.height) /
                                                                                                                  100 -
                                                                                                                50
                                                                                                              }px`
              "
            >
              <source :src="item.url_midia_colaboracao" />
            </video>
            <div
              v-html="item.dsc_texto_colaboracao"
              class="px-3 py-3 font-weight-normal"
              style="color: rgb(255, 255, 255); font-family: 'GaleanaCondensed-Regular'"
              :style="{
                lineHeight: lineHeightFullScreen,
                fontSize: bodyTextSizeFullSreen,
                wordBreak: 'break-word',
              }"
            ></div>
          </div>
        </div>
      </div>
      <div
        v-else-if="renderMode === 'midia_texto'"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'width: 100%;'
            : 'width: 100%; display: grid; grid-template-columns: 1fr;'
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image' && midiaOrientation === 'horizontal'
            ? 'd-flex align-center'
            : item.dsc_tipo_midia_colaboracao === 'video' &&
              midiaOrientation === 'horizontal'
            ? ''
            : ''
        "
      >
        <div
          v-if="midiaOrientation && midiaOrientation === 'horizontal'"
          class="d-flex flex-column align-center"
        >
          <img
            v-if="item.dsc_tipo_midia_colaboracao === 'image'"
            id="image"
            class="pa-2"
            :src="item.url_midia_colaboracao"
            :style="
              isFullScreen
                ? `max-width: ${
                    (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                  }px;
                                                                                                      min-width: ${
                                                                                                        (percentScreenDim.fullScreenMinWidth *
                                                                                                          screenDimensions.width) /
                                                                                                        100
                                                                                                      }px;
                                                                                                      max-height: ${
                                                                                                        (percentScreenDim.fullScreenMaxHeight *
                                                                                                          screenDimensions.height) /
                                                                                                        100
                                                                                                      }px;
                                                                                                      min-height: ${
                                                                                                        (percentScreenDim.fullScreenMinHeight *
                                                                                                          screenDimensions.height) /
                                                                                                        100
                                                                                                      }px;`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px;
                                                                                                      max-height: ${
                                                                                                        (percentScreenDim.maxHeight *
                                                                                                          screenDimensions.height) /
                                                                                                          100 -
                                                                                                        50
                                                                                                      }px`
            "
          />
          <video
            v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
            autoplay
            :id="`${item.id_colaboracao}`"
            :key="item.url_midia_colaboracao"
            style="justify-self: center"
            class="pa-2"
            :style="
              isFullScreen
                ? `max-height: ${
                    (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) / 100
                  }px; 
                                                      max-width: ${
                                                        (percentScreenDim.fullScreenMaxWidth *
                                                          screenDimensions.width) /
                                                        100
                                                      }px`
                : `max-width: ${
                    (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                  }px; 
                                                  max-height: ${
                                                    (percentScreenDim.maxHeight *
                                                      screenDimensions.height) /
                                                      100 -
                                                    50
                                                  }px`
            "
          >
            <source :src="item.url_midia_colaboracao" />
          </video>
          <div
            v-html="item.dsc_texto_colaboracao"
            class="px-3 py-3 font-weight-normal"
            style="
              color: rgb(255, 255, 255);
              font-family: 'GaleanaCondensed-Regular; background-color: rgb(24, 1, 243); ';
            "
            :style="{
              lineHeight: lineHeight,
              fontSize: bodyTextSize,
              wordBreak: 'break-word',
            }"
          ></div>
        </div>
        <div
          v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
          class="d-flex"
        >
          <div class="pa-2 bg-media-vertical" style="background: rgb(9, 4, 62)">
            <img
              v-if="item.dsc_tipo_midia_colaboracao === 'image'"
              id="image"
              :src="item.url_midia_colaboracao"
              :style="
                isFullScreen
                  ? `max-width: ${
                      (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) / 100
                    }px;
                                                                                                              min-width: ${
                                                                                                                (percentScreenDim.fullScreenMinWidth *
                                                                                                                  screenDimensions.width) /
                                                                                                                100
                                                                                                              }px;
                                                                                                              max-height: ${
                                                                                                                (percentScreenDim.fullScreenMaxHeight *
                                                                                                                  screenDimensions.height) /
                                                                                                                100
                                                                                                              }px;
                                                                                                              min-height: ${
                                                                                                                (percentScreenDim.fullScreenMinHeight *
                                                                                                                  screenDimensions.height) /
                                                                                                                100
                                                                                                              }px;`
                  : `max-width: ${
                      (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                    }px; 
                                                                                                              max-height: ${
                                                                                                                (percentScreenDim.maxHeight *
                                                                                                                  screenDimensions.height) /
                                                                                                                  100 -
                                                                                                                50
                                                                                                              }px`
              "
            />
            <video
              v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
              autoplay
              :id="`${item.id_colaboracao}`"
              :key="item.url_midia_colaboracao"
              style="justify-self: center"
              :style="
                isFullScreen
                  ? `max-height: ${
                      (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                      100
                    }px; 
                                                                                                              max-width: ${
                                                                                                                (percentScreenDim.fullScreenMaxWidth *
                                                                                                                  screenDimensions.width) /
                                                                                                                100
                                                                                                              }px`
                  : `max-width: 100%; 
                                                      max-height: ${
                                                        (percentScreenDim.maxHeight *
                                                          screenDimensions.height) /
                                                          100 -
                                                        50
                                                      }px`
              "
            >
              <source :src="item.url_midia_colaboracao" />
            </video>
          </div>
          <div
            class="d-flex flex-column align-self-end"
            style="
              background: rgb(9, 4, 62) !important;
              min-height: 160px;
              max-height: 180px;
            "
            :style="`max-width: ${
              (33.5 * screenDimensions.width) / 100
            }px; background: rgb(9, 4, 62) !important;`"
          >
            <header
              v-if="
                !hideUserInfo &&
                item.url_midia_colaboracao &&
                item.dsc_texto_colaboracao &&
                midiaOrientation === 'vertical'
              "
              class="d-flex flex-wrap-1 px-2 py-2"
            >
              <div class="d-flex align-center" style="margin: 0 auto">
                <span
                  class="text-uppercase ml-2 header-font"
                  style="
                    color: rgb(255, 255, 255) !important;
                    font-size: 1.5rem;
                    font-weight: 600;
                    font-family: 'NerkoOneRegular !important';
                  "
                >
                  <template v-if="flgExibirUf && item.dsc_uf_colaborador">
                    {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
                  </template>
                  <template v-else>
                    {{ item.dsc_nome_colaborador }}
                  </template>
                </span>
              </div>
              <div class="d-flex align-center align-self-end justify-self-end">
                <v-icon
                  size="36"
                  class="ma-0 pa-0 ml-1"
                  color="rgb(255, 255, 255)"
                  style="transform: scaleX(-1)"
                >
                  mdi-chat-outline
                </v-icon>
              </div>
            </header>
            <div
              v-html="item.dsc_texto_colaboracao"
              class="px-3 py-3 font-weight-normal d-flex align-center align-self-center"
              style="color: rgb(255, 255, 255); font-family: 'GaleanaCondensed-Regular'"
              :style="{
                lineHeight: lineHeight,
                fontSize: bodyTextSize,
                wordBreak: 'break-word',
              }"
            ></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flgExibirUf: Boolean,
  },
  data() {
    return {
      midiaOrientation: null,
      midiaDimension: {},
      divMidiaWrapperDimension: null,
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 40,
        minWidth: 20,
        minHeight: 30,
        maxHeight: 70,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 80,
        fullScreenMinWidth: 20,
        fullScreenMinHeight: 60,
      },
    };
  },
  created() {
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  computed: {
    renderMode() {
      if (
        this.item.dsc_tipo_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "audio"
      ) {
        return "audio";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        (!this.item.dsc_texto_colaboracao || !this.item.flg_exibir_texto)
      ) {
        return "midia";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen
      ) {
        return "midia_texto_fullscreen";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.flg_exibir_texto &&
        this.item.dsc_texto_colaboracao &&
        !this.isFullScreen
      ) {
        return "midia_texto";
      } else if (
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen &&
        !this.url_midia_colaboracao
      ) {
        return "texto_fullscreen";
      }
      return "text";
    },
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.3rem"
          : numChars > 40 && numChars <= 80
          ? "2.2rem"
          : numChars > 80 && numChars <= 120
          ? "2rem"
          : numChars > 120 && numChars <= 160
          ? "1.8rem"
          : numChars > 160 && numChars <= 200
          ? "1.7rem"
          : numChars > 200 && numChars <= 240
          ? "1.6rem"
          : numChars > 240 && numChars <= 280
          ? "1.4rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.5rem"
          : numChars > 40 && numChars <= 80
          ? "2.4rem"
          : numChars > 80 && numChars <= 120
          ? "2.2rem"
          : numChars > 120 && numChars <= 160
          ? "2rem"
          : numChars > 160 && numChars <= 200
          ? "1.9rem"
          : numChars > 200 && numChars <= 240
          ? "1.7rem"
          : numChars > 240 && numChars <= 280
          ? "1.6rem"
          : "1.5rem";

      return lineHeight;
    },
    bodyTextSizeFullSreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.7rem"
          : numChars > 80 && numChars <= 120
          ? "2.5rem"
          : numChars > 120 && numChars <= 160
          ? "2.3rem"
          : numChars > 160 && numChars <= 200
          ? "2rem"
          : numChars > 200 && numChars <= 240
          ? "1.9rem"
          : numChars > 240 && numChars <= 280
          ? "1.8rem"
          : "1.5rem";
      return size;
    },
    lineHeightFullScreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.7rem"
          : numChars > 80 && numChars <= 120
          ? "2.5rem"
          : numChars > 120 && numChars <= 160
          ? "2.3rem"
          : numChars > 160 && numChars <= 200
          ? "2.1rem"
          : numChars > 200 && numChars <= 240
          ? "2rem"
          : numChars > 240 && numChars <= 280
          ? "1.9rem"
          : "1.5rem";

      return lineHeight;
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          20; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
            100 +
          50; // 80% of screen height + 50px
        if (this.renderMode === "texto_fullscreen") {
          minWidth =
            (this.percentScreenDim.fullScreenMinWidth -
              10 * this.screenDimensions.width) /
            100;
          minHeight =
            (this.percentScreenDim.fullScreenMinHeight -
              30 * this.screenDimensions.height) /
            100;
        }
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                               min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;
        return fullScreenStyle;
      }
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-end"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";

      // regras para visualização normal, sem modo tela cheia
      maxWidth = (this.percentScreenDim.maxWidth * this.screenDimensions.width) / 100; // 40% of screen width
      maxHeight = (this.percentScreenDim.maxHeight * this.screenDimensions.height) / 100; // 80% of screen height
      // const textMaxWidth = (33.5 * this.screenDimensions.width) / 100; // 40% of screen width
      // const textMaxHeight = (15.5 * this.screenDimensions.height) / 100; // 20% of screen height)
      const dimensions =
        ["video", "image"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        !this.item.dsc_texto_colaboracao
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "horizontal"
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "vertical"
          ? `max-width: auto !important; max-height: ${maxHeight}px !important;`
          : `width: 640px; height: 160px;`;

      const array = position.split(";").concat(dimensions.split(";"));
      return array.filter((item) => item).join(";");
    },
  },
  methods: {
    getDivMidiaWrapperDimension() {
      if (
        this.item.url_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "video"
      ) {
        const item = document.getElementById(`${this.item.id_colaboracao}`);
        return { width: item.offsetWidth, height: item.offsetHeight };
      }
      return null;
    },
    getMidiaOrientation() {
      if (this.item.url_midia_colaboracao) {
        if (this.item.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.item.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.item.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
  },
  watch: {
    item: function (newValue) {
      if (newValue.url_midia_colaboracao) {
        this.getMidiaOrientation();
        this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
      this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "GaleanaCondensed-Black";
  src: url("@/assets/fonts/Latinotype-Galeana-Condensed-Black.otf") format("opentype");
}

@font-face {
  font-family: "GaleanaCondensed-Regular";
  src: url("@/assets/fonts/Latinotype-Galeana-Condensed-Regular.otf") format("opentype");
}

.header-font {
  font-family: "GaleanaCondensed-Black" !important;
  text-transform: uppercase !important;
}

header {
  width: 100%;
  background-color: rgb(24, 1, 243);
}

section {
  width: 100%;
}

.bg-media-vertical {
  background: rgb(9, 4, 62);
}
</style>
